import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Multiselect from "vue-multiselect";
import * as VueGoogleMaps from 'vue2-google-maps'
import './main.scss'
import Swal from "sweetalert2";
import VueConfirmDialog from 'vue-confirm-dialog'
import VueAnalytics from 'vue-analytics';
import VueLazyload from 'vue-lazyload';
import DatePicker from "vue2-datepicker";
import fullscreen  from "vue-fullscreen"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faUserSecret)


Vue.config.productionTip = false
Vue.config.productionTip = false
Vue.use(fullscreen)
Vue.use(DatePicker)
Vue.use(VueLazyload)
Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.use(require('vue-moment'));
Vue.use(VueConfirmDialog)
Vue.component('multiselect', Multiselect, 'vue-confirm-dialog', VueConfirmDialog.default);
Vue.use(VueAnalytics, {
  id: 'UA-176023459-1',
  router
})
Vue.use(VueGoogleMaps, {
  load: {
    //set google map api key
    key: 'AIzaSyBXhFJtC8U_3ErmI0OhuvrEAOkb12HG9os',
    libraries: 'places',
    language: 'th',
    region: 'TH'
  },
  installComponents: true

})
Vue.prototype.$swal = Swal

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
